import React, { useState, useEffect } from "react";

const SearchFilter = ({ searchValue, onSearchChange, filters, onFilterChange }) => {
  const [localSearch, setLocalSearch] = useState(searchValue || "");

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchChange(localSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [localSearch, onSearchChange]);

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      <input
        type="text"
        placeholder="Search..."
        className="input input-bordered input-sm flex-1 min-w-[200px]"
        value={localSearch}
        onChange={(e) => setLocalSearch(e.target.value)}
      />
      {filters.map((filter) => (
        <select
          key={filter.name}
          className="select select-bordered select-sm"
          value={filter.value}
          onChange={(e) => onFilterChange(filter.name, e.target.value)}
        >
          <option value="">{filter.label}</option>
          {filter.options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ))}
    </div>
  );
};

export default SearchFilter;
